import {Component} from 'react';
import './GameBoardActivities/jigsawPuzzle.css';
import ImageCard from '../shared-components/image_card';
import {shuffleArray} from '../../objects/CommonUse/shuffleArray';
import Button from 'react-bootstrap/Button';

class JigsawPuzzleModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         imgDir: "./assets/Activities/HaveFun/",
         buttonDisabled: false,
         puzzleStarted: false,
         displayPicture: false,
         callRender: false,
       };    
       this.saveClicksCount = 0;
       this.puzzleName = "";
       this.pictureArr = [];
       this.pictureRow = [];
       this.nbrMoves = 0;
       this.bestScore = 0;
       this.nbrPuzzlesCompleted = this.props.score.nbrCompleted;
       this.maxNbrPuzzles = this.props.nbrGames;
       this.nbrPuzzlesAttempted = 0;
       this.totalPoints = 0;
       this.puzzleChoice = 99;
       this.puzzleCompleted = false;
       this.buttonType = "start";
       this.score = this.props.score;
       this.finishText = "";
       this.nbrPoints = 0;
  }
     
 selectPuzzle(){
      this.setState({puzzleStarted: true});
      this.nbrPuzzlesAttempted += 1;
      this.congratsMsg = "";
      let maxPuzzles = this.props.puzzleArr.length;
      this.puzzleChoice = this.puzzleChoice + 1;
      if (this.puzzleChoice > maxPuzzles){
           this.puzzleChoice = 0;
      }
      this.pictureArr = [];
      this.pictureRow = [];
      this.nbrMoves = 0;
      this.puzzleCompleted = false;
      let imgIndx = 0;
      this.chosenPuzzle = this.props.puzzleArr[this.puzzleChoice];
      this.puzzleCompletedPicture = this.state.imgDir + this.props.pictureDir + "/" + 
        this.chosenPuzzle.puzzleName;
      this.rowCount = this.chosenPuzzle.rows;
      this.columnCount = this.chosenPuzzle.columns;
      this.totalNbrPuzzlePieces = +this.columnCount * +this.rowCount;
      this.nbrPoints = 0;
      this.puzzleName = this.chosenPuzzle.puzzleName;
      this.pictureArray = shuffleArray(this.chosenPuzzle.imageList);
      this.setImageClass();
      for (let i=0; i < this.rowCount; i++){
          for (let j=0; j<this.columnCount; j++){
              let imageURL = this.state.imgDir + this.props.pictureDir + "/" + 
                this.chosenPuzzle.imageList[imgIndx].imageURL
              let pictureObj = {imageURL: imageURL, 
                imageClass: this.imageSize, imageRow: this.pictureArray[imgIndx].row,
                imageColumn: this.pictureArray[imgIndx].column};
              this.pictureRow.push(pictureObj);
              imgIndx = imgIndx + 1;
          }
          this.pictureArr.push(this.pictureRow);
          this.pictureRow = [];
      }
      this.setState({buttonDisabled: true});
      this.props.startTimer();
      }

    setImageClass(){
        //  level 1 -> 6 pieces, 2 x 3 and 3 x 2
        //  level 2 -> 9 pieces, 3 x 3
        //  level 3 -> 12 pieces, 3 x 4 and 4 x 3
        //  level 4 -> 16 pieces, 4 x 4  
        //  level 5 -> 20 pieces, 4 x 5 and 5 x 4
        let errorFound = false;
        let errorMsg = "";
        this.imageSize = "puzzle-image-column-"
        if (this.columnCount <= 6){
            this.imageSize += +this.columnCount;
            this.imageSize += " puzzle-image-row-";
            if (this.rowCount <= 5){
                this.imageSize += +this.rowCount;
            }else{
                errorFound = true;
                errorMsg={errorText: "puzzle has more than 5 columns - not supported"}
            }
        }else{
            errorFound = true;
            errorMsg={errorText: "puzzle has more than 5 rows - not supported"}
        }
        if (errorFound === true){
            this.props.onError(errorMsg);
        }
    }

    onClick(picturesList){
      if (this.props.stopActivity ===true){ 
          this.congratsMsg = "Time has runout for this puzzle. "
          this.nbrPoints = 0;
          this.finishPuzzle(); 
          this.nbrMoves = 0;
          this.saveClicksCount = 0;
      }else{
         if (this.puzzleCompleted ===false){
            this.processPictureClicked(picturesList);
         }
      }
      if (this.nbrPuzzlesCompleted >= +this.maxNbrPuzzles){
          this.buttonType = "Finish"
      }
      this.setState({callRender: true});
    }

    processPictureClicked(picturesList){
      this.saveClicksCount += 1;
      if (this.saveClicksCount ===1){
          this.save1Obj = this.findPicture(picturesList);
          let imageClass = "picture-has-been-clicked " + this.imageSize;
          this.setClass(this.save1Obj, imageClass);
      }
      if (this.saveClicksCount ===2){
          this.saveClick2 = picturesList;
          this.save2Obj = this.findPicture(picturesList);
          // if second picture is same as the first picture then reset the
          // opacity on the picture.
          if (this.save1Obj ===this.save2Obj){
              this.setClass(this.save1Obj, this.imageSize)
          }else{
              this.nbrMoves += 1;
              this.swapPictures();
              this.setClass(this.save1Obj, this.imageSize)
              this.setClass(this.save2Obj, this.imageSize)
              this.checkIfDone();
              if (this.puzzleCompleted === true){
                  this.congratsMsg = "Congratulations!! You completed the puzzle in " +
                      this.nbrMoves + " moves." 
                  this.nbrPoints = this.totalNbrPuzzlePieces - (+this.nbrMoves/2).toFixed(0);
                  this.totalPoints = this.nbrPoints + this.totalPoints;
                  this.finishPuzzle();
              }
          }
          this.saveClicksCount = 0;
      }
  }

  finishPuzzle(){
      this.props.stopTimer();
      this.nbrPuzzlesCompleted += 1;
      this.bestScore = +this.bestScore + +(+this.totalNbrPuzzlePieces / 2).toFixed(0);
      if (this.nbrPuzzlesCompleted >= this.maxNbrPuzzles){
          this.buttonText = "finish"
      }else{
          this.congratsMsg += "  Want to try another one?";
          this.nextPuzzleMsg =  "Click the 'New Puzzle' button to get a new puzzle to solve."
          if (this.props.friendInfo.friendImgURL){
              let indx = this.nbrPuzzlesCompleted - 1;
              this.comment = this.props.friendInfo.commentTable[indx];
              this.setState({displayPicture: true});
          }
          this.setState({buttonDisabled: false});
      }
  }

  finishThisActivity(){
      this.finishText = "You have completed all puzzles for this round.  Click the finish button."
      this.score.type = "finish";
      this.setScoreValues();
      this.props.onGameOver(this.score);
      this.setState({callRender: true});
  }

  doneButtonClicked(){
      this.score.type = "done";
      this.setScoreValues();
      this.props.onGameOver(this.score);
  }

  setScoreValues(){
      this.score.points = this.totalPoints;
      this.score.gamesRemaining = this.props.score.gamesRemaining - this.nbrPuzzlesCompleted;
      if (this.bestScore > this.totalPoints){
          this.score.maxScore = this.bestScore;
      }else{
          this.score.maxScore = this.totalPoints;
      }
      this.score.nbrAttempted = this.nbrPuzzlesAttempted;
      if (this.score.points >= this.score.maxScore &&
          this.score.gamesRemaining <= 0){
          this.score.newLevelEarned = true;
      }else{
          this.score.newLevelEarned = false;
      }
  }

  findPicture(picturesList){
    var pictureRowArr = [];
    var pictureArrObj = '';
    for (let i=0; i < this.rowCount; i++){
      pictureRowArr = this.pictureArr[i];
      for (let j=0; j<this.columnCount; j++){
          pictureArrObj = pictureRowArr[j];
          if (pictureArrObj.imageURL ===picturesList.imageURL){
              let saveObj = {imageURL: picturesList.imageURL, imageRow: picturesList.imageRow,
                imageColumn: picturesList.imageColumn, currentColIdx: j, currentRowIdx: i};
              return saveObj;
          }
      }
    }
  }

  setClass(pictureObj, newClass){
      var pictureRowArr = [];
      pictureRowArr = this.pictureArr[pictureObj.currentRowIdx];
      pictureRowArr[pictureObj.currentColIdx].imageClass = newClass;
      this.pictureArr[pictureObj.currentRowIdx] = pictureRowArr;
  }

  swapPictures(){
      var pictureRow = [];
      // move 1st selected picture info to 2nd picture position
      pictureRow = this.pictureArr[this.save2Obj.currentRowIdx];
      pictureRow[this.save2Obj.currentColIdx].imageURL = this.save1Obj.imageURL;
      pictureRow[this.save2Obj.currentColIdx].imageRow = this.save1Obj.imageRow;
      pictureRow[this.save2Obj.currentColIdx].imageColumn = this.save1Obj.imageColumn;
      this.pictureArr[this.save2Obj.currentRowIdx] = pictureRow;
      // move 2nd selected picture info to 1st picture position
      pictureRow = this.pictureArr[this.save1Obj.currentRowIdx];
      pictureRow[this.save1Obj.currentColIdx].imageURL = this.save2Obj.imageURL;
      pictureRow[this.save1Obj.currentColIdx].imageRow = this.save2Obj.imageRow;
      pictureRow[this.save1Obj.currentColIdx].imageColumn = this.save2Obj.imageColumn;
      this.pictureArr[this.save1Obj.currentRowIdx] = pictureRow;
   }
 
  checkIfDone(){
      this.puzzleCompleted = true;
      var pictureRowArr = [];
      for (let i=0; i<this.rowCount; i++){
          pictureRowArr = this.pictureArr[i];
          for(let j=0; j<this.columnCount; j++){
              if (pictureRowArr[j].imageRow !== i+1 ||
                  pictureRowArr[j].imageColumn !== j+1){
                    this.puzzleCompleted = false;
                    break;
              }
          }
      }
  }
 
  render() { 
        this.pictureOutput = [];
        for (let i=0; i<this.pictureArr.length; i++){
            this.rowOfPictures = this.pictureArr[i];
            this.pictureDisplay= this.rowOfPictures.map((picturesList, key)  =>
                <ImageCard imageInfo={picturesList} key={key}
                onClick={() => this.onClick(picturesList)}/> 
                );
            this.pictureOutput.push(this.pictureDisplay)
        }
   
  return <>
   <div>
        <div>{this.finishText}</div>
        <div className="row">
            {this.buttonType === "start" ?
                <>
                    <div className="col-sm-2">
                        <Button className=" puzzle-text p-0 text-center" variant="primary" 
                            disabled={this.state.buttonDisabled} 
                            onClick={() => this.selectPuzzle()}>
                                New Puzzle   
                        </Button>
                    </div>
                    <div className="col-sm-2 puzzle-text">
                        <Button className="p-0 text-right" variant="primary"
                            onClick={() => this.doneButtonClicked()}>
                                Done
                        </Button>
                    </div>
                </>
            :
              <div className="col-sm-4 text-left">
                <Button className=" puzzle-text p-0 text-right" variant="primary" 
                    onClick={() => this.finishThisActivity()}>
                            Finish
                </Button>
              </div>
            }
            
            <div className="col-sm-8 p-0 font-weight-bold">
                <div className="puzzle-text">{this.congratsMsg}</div>
            </div>
        </div>
        {this.state.puzzleStarted ?
          <span>
            <div className="puzzle-text mt-2"><b>Nbr Points Earned:</b>&nbsp; {this.nbrPoints} &nbsp;&nbsp;&nbsp;
                <b>Cumulative Points:</b> &nbsp; {this.totalPoints}&nbsp;&nbsp;&nbsp;
            </div>
            <div className="ml-5 puzzle-text">
                <b>Puzzles Completed:</b>&nbsp; {this.nbrPuzzlesCompleted}&nbsp;of&nbsp;{+this.maxNbrPuzzles}
            </div>
                <div className="col-sm-9">
                  <div>
                    {this.pictureOutput[0]}
                  </div>
                  <div>  
                    {this.pictureOutput[1]}
                  </div>
                  {this.chosenPuzzle.rows > 2 ?
                      <div>
                        {this.pictureOutput[2]}
                      </div>
                  :
                      null
                  }
                  {this.chosenPuzzle.rows > 3 ?
                      <div>
                          {this.pictureOutput[3]}
                      </div>
                  :
                      null
                  }
                   {this.chosenPuzzle.rows > 4 ?
                      <div>
                          {this.pictureOutput[4]}
                      </div>
                  :
                      null
                  }
              
            </div>
            <div>
                <img src={this.puzzleCompletedPicture} 
                     className="puzzle-completed-picture-position  completed-picture-size" alt="puzzlePicture"/>
            </div>
          </span>
        :
            null
        }

        
        {this.state.displayPicture   ?
                  <span>
                      <div>
                          <img src={this.props.friendInfo.friendImgURL}  className="friend-puzzle-position-img" 
                              alt="friendPicture"/>
                      </div>  
                      <div className="speech-puzzle-position speech-puzzle-activity right" >
                          {this.comment}
                      </div>
                  </span>
                :
                    null
                }
{/*
         {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
*/}
           
      </div>
    </>
  }

 
}
export default JigsawPuzzleModal;